import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ConsumerTypesActions } from './consumer-types.actions';
import { AsyncActions } from './consumer-types.actions';
import {ConsumerType} from '@emm/core/models/consumer-type.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {SearchFilter} from '@emm/core/models/search-filter';
import {genericSort} from '@emm/core/util/sort.util';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const consumerTypesFeatureKey = 'consumerTypes';

export interface ConsumerTypesState extends EntityState<ConsumerType>, AsyncActionState {
    selectedTag: string | null;
    searchFilter: SearchFilter;
}

export const adapter: EntityAdapter<ConsumerType> = createEntityAdapter<ConsumerType>({
    selectId: (item: ConsumerType) => item.tag,
    sortComparer: genericSort<ConsumerType>((val) => val.name),
});

export const initialState: ConsumerTypesState = adapter.getInitialState({
    selectedTag: null,
    searchFilter: null,
    ...asyncActionState.initial,
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const consumerTypesReducer = withLoadables<ConsumerTypesState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(ConsumerTypesActions.loadAll, (state: ConsumerTypesState) => ({
        ...state,
        selectedTag: null,
    })),

    on(ConsumerTypesActions.loadAllSuccess, (state: ConsumerTypesState, { consumerTypes }) =>
        adapter.setAll(consumerTypes, state)
    ),

    on(ConsumerTypesActions.select, (state: ConsumerTypesState, { tag }) => ({
        ...state,
        selectedTag: tag,
    })),

    on(ConsumerTypesActions.search, (state: ConsumerTypesState, action) => ({
        ...state,
        searchFilter: action.filter,
    }))

);
